<template lang="pug">
el-dialog(:visible.sync="visible" title="Изпрати email" width="500px" :close-on-click-modal="false")
  el-form(id="email-invoice-dialog-form" :model="formData" @submit.native.prevent="submit")
    el-form-item(label="До")
      strong {{ email }}
    el-form-item(prop="subject" label="Относно")
      el-input(v-model="formData.subject")
    el-form-item(prop="text" label="Текст")
      el-input(v-model="formData.text" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }")
    div {{ lang === 'bg' ? 'Българската' : 'Английската' }} фактура ще бъде прикачена към имейла автоматично
  template(slot="footer" class="dialog-footer")
    el-button(@click="hide") Затвори
    el-button(type="primary" form="email-invoice-dialog-form" native-type="submit" :loading="loading") Изпрати
</template>

<script>
export default {
  name: 'EmailInvoiceDialog',
  data() {
    return {
      visible: false,
      loading: false,
      lang: 'bg',
      record: null,
      email: '',
      formData: {
        subject: '',
        text: '',
      }
    }
  },
  methods: {
    show(lang = 'bg', record, Company, Contragent) {
      this.lang = lang
      this.record = record
      this.email = Contragent.email
      const invoiceNum = this.common.formatInvoiceNum(record.num)

      if (lang !== 'bg') {
        this.formData = {
          subject: `${Company.en.name} - ${record.document === 3 ? 'Notice' : 'Invoice'} ${invoiceNum}`,
          text: `Thank you for being our client! Please find attached your invoice.`
        }
      } else {
        this.formData = {
          subject: `${Company.name} - ${record.document === 3 ? 'Кредитно известие' : 'Фактура'} ${invoiceNum}`,
          text: `Благодарим ви, че сте наш клиент! Приложено ще намерите Вашия финансов документ.`
        }
      }

      this.visible = true
    },
    hide() {
      this.visible = false
    },
    submit() {
      this.loading = true
      this.$http.post(`/payments/${this.record.id}/email`, {
        lang: this.lang,
        subject: this.formData.subject,
        text: this.formData.text
      }).then(response => {
        console.log(response)
        this.hide()
        this.$notify({title: 'Email', message: 'Успешно изпратен', type: 'warning'})
      }).catch(error => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading num. Check console.'})
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
